module.exports = __webpack_public_path__ + "static/img/contact_logo2.b301cc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo2.png
// module id = mFnS
// module chunks = 1